import type { SpatialRectangle } from "../types/geometry/SpatialRectangle"
import type { Distance } from "../types/units/Units"

export const BoxToRectangle = <T extends number = Distance>([x, y, x2, y2]: [
  T,
  T,
  T,
  T,
]): SpatialRectangle<T> => ({
  x: x as T,
  y: y as T,
  width: (x2 - x) as T,
  height: (y2 - y) as T,
})
